// @flow

import * as React from "react";
import { withRouter } from "react-router-dom";
import Footer from "../Footer";

import { type ReactElementRef } from "../../types/react";

import styles from "./PageLayout.scss";

type PageLayoutScrollContextValue = {
  scrollToTop: () => void
};

export const PageLayoutScrollContext = React.createContext<PageLayoutScrollContextValue>({
  scrollToTop: () => {}
});

type PageLayoutProps = {
  children: React.Node
};

class PageLayout extends React.Component<PageLayoutProps> {
  wrapperRef: ReactElementRef<HTMLDivElement> = React.createRef();

  scrollToTop = () => {
    if (!this.wrapperRef.current) {
      return;
    }

    this.wrapperRef.current.scrollTop = 0;
  };

  render() {
    const { children } = this.props;
    return (
      <>
        <div ref={this.wrapperRef} className={styles.wrapper}>
          <div className={styles.content}>
            <div className={styles.contentInner}>
              <PageLayoutScrollContext.Provider value={{ scrollToTop: this.scrollToTop }}>
                {children}
              </PageLayoutScrollContext.Provider>
            </div>
          </div>
          <Footer type="portal" />
        </div>
      </>
    );
  }
}

export default withRouter(PageLayout);
